<template>
  <div>
    <!--search form-->
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="主题">
        <el-input v-model="searchForm.topicName" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡片名称">
        <el-input v-model="searchForm.cardName" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡片类型">
        <el-select v-model="searchForm.cardType" clearable filterable>
          <el-option
            v-for="item in giftCardTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="有效期类型">
        <el-select v-model="searchForm.validType" clearable filterable>
          <el-option
            v-for="item in giftCardValidTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in giftCardStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 10px" class="table-btns">
      <div class="rl">
        <el-button size="mini" @click="handleGotoOrder">礼品卡订单</el-button>
        <el-button size="mini" @click="handleGotoOrderRefund"
          >礼品卡退款申请</el-button
        >
      </div>
      <div class="rl"></div>
    </div>

    <!--table-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column label="主题" prop="topicName" align="center">
      </el-table-column>
      <el-table-column label="卡片名称" prop="cardName" align="center">
      </el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.topicCover"
            style="width: 150px; height: 50px;"
          />
        </template>
      </el-table-column>
      <el-table-column label="卡片类型" prop="cardTypeName" align="center">
      </el-table-column>
      <el-table-column label="卡片面值" prop="amount" align="center">
      </el-table-column>
      <el-table-column label="有效期类型" prop="validTypeName" align="center">
      </el-table-column>

      <el-table-column label="状态" prop="statusName" align="center">
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleEdit(scope.row)"
          >
            编辑</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleGiftCard(scope.row)"
          >
            礼品卡记录
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <gift-card-edit ref="editRef" @refresh="loadPage"></gift-card-edit>
  </div>
</template>
<script>
import {
  giftCardTypeApi,
  giftCardValidTypeApi,
  giftCardSpecPage
} from "@/api/giftCard";
import GiftCardEdit from "./components/edit.vue";
export default {
  name: "BizGiftCard",
  components: { GiftCardEdit },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      giftCardTypeOptions: [],
      giftCardValidTypeOptions: [],
      giftCardStatusOptions: [
        {
          value: 0,
          label: "禁用"
        },
        {
          value: 1,
          label: "启用"
        }
      ],

      loading: false,
      tableData: []
    };
  },
  created() {
    this.getGiftCardType();
    this.getGiftCardValidType();
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    getGiftCardType() {
      giftCardTypeApi().then(res => {
        if (res.data.status == 100) {
          this.giftCardTypeOptions = res.data.results;
        }
      });
    },
    getGiftCardValidType() {
      giftCardValidTypeApi().then(res => {
        if (res.data.status == 100) {
          this.giftCardValidTypeOptions = res.data.results;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      giftCardSpecPage(this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.searchForm.total = res.data.results.total;
            this.tableData = res.data.results.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleAdd() {
      const dataSource = {
        cardTypeOptions: this.giftCardTypeOptions,
        validTypeOptions: this.giftCardValidTypeOptions,
        statusOptions: this.giftCardStatusOptions
      };
      this.$refs.editRef.open(undefined, dataSource);
    },
    handleEdit(row) {
      const dataSource = {
        cardTypeOptions: this.giftCardTypeOptions,
        validTypeOptions: this.giftCardValidTypeOptions,
        statusOptions: this.giftCardStatusOptions
      };
      this.$refs.editRef.open(row, dataSource);
    },
    handleGiftCard(row) {
      this.$router.push({
        path: "/bizGiftCardRecord",
        query: {
          id: row.id
        }
      });
    },
    handleGotoOrderRefund() {
      this.$router.push({
        path: "/bizGiftCardOrderRefund"
      });
    },
    handleGotoOrder() {
      this.$router.push({
        path: "/bizGiftCardOrder"
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// index.vue?87253372